import React from 'react';
import { useLocation } from 'react-router-dom';
import EncabezadoApp from 'components/EncabezadoApp';
import ErrorBoundary from 'components/ui/ErrorBoundary';

export { puedeInspeccionar } from './navItems';

/**
 * Marco de toda pantalla administrativa, igual al PaginaBase de fincas:
 * header común (sticky) con el menú por rol, título grande de la pantalla (h1), una
 * línea de descripción, las acciones y el contenido. Desde el 2026-10-20 el
 * encabezado va a todo el ancho (shared 859cb56) y el contenido también, con el
 * mismo relleno lateral que la fila del encabezado (16 / 24 / 32 px): el borde
 * del contenido queda alineado con el logo. En el teléfono las acciones van
 * apiladas y a todo el ancho; desde sm, en fila.
 * Si el contenido se cae al dibujarse, el aviso sale debajo del encabezado
 * (que sigue a mano) y se limpia al cambiar de ruta.
 */
export default function AppShell({ titulo, descripcion, acciones, children }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-background)' }}>
      <EncabezadoApp />
      <main>
        <div data-testid="contenido-pagina" className="w-full px-[16px] sm:px-[24px] lg:px-[32px] py-6 md:py-8">
          {titulo && <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground">{titulo}</h1>}
          {descripcion && <p className="mt-1 text-sm text-muted-foreground">{descripcion}</p>}
          {acciones && (
            <div
              data-testid="acciones-pagina"
              className="mt-4 flex flex-col gap-2 empty:hidden sm:flex-row sm:flex-wrap sm:items-center [&>*]:w-full sm:[&>*]:w-auto"
            >
              {acciones}
            </div>
          )}
          <div className="mt-6">
            <ErrorBoundary resetKeys={[pathname]} pantallaCompleta={false} hubUrl={null}>{children}</ErrorBoundary>
          </div>
        </div>
      </main>
    </div>
  );
}
